var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberNewsResponsive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide:newspaper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.6875 16.7207H14.6875C15.0853 16.7207 15.4669 16.5627 15.7482 16.2814C16.0295 16.0001 16.1875 15.6185 16.1875 15.2207V3.2207C16.1875 2.82288 16.0295 2.44135 15.7482 2.16004C15.4669 1.87874 15.0853 1.7207 14.6875 1.7207H5.6875C5.28967 1.7207 4.90814 1.87874 4.62684 2.16004C4.34553 2.44135 4.1875 2.82288 4.1875 3.2207V15.2207C4.1875 15.6185 4.02946 16.0001 3.74816 16.2814C3.46686 16.5627 3.08532 16.7207 2.6875 16.7207ZM2.6875 16.7207C2.28968 16.7207 1.90814 16.5627 1.62684 16.2814C1.34554 16.0001 1.1875 15.6185 1.1875 15.2207V8.4707C1.1875 7.6457 1.8625 6.9707 2.6875 6.9707H4.1875M13.1875 10.7207H7.1875M10.9375 13.7207H7.1875",
    stroke: "#5A5A5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.1875 4.7207H13.1875V7.7207H7.1875V4.7207Z",
    stroke: "#5A5A5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberNewsResponsive);
export default __webpack_public_path__ + "static/media/NumberNewsResponsive.da0a6dd83c61e15ab3184dc632a022ee.svg";
export { ForwardRef as ReactComponent };